import React from 'react'

function TableScrollContainer (props) {
  return (
    <div className='w-full overflow-x-auto text-sm'>
      {props.children}
    </div>
  )
}

export default TableScrollContainer
